import React from 'react';
import PropTypes from 'prop-types';
import styles from './Dropdown.module.scss';

const DropdownItems = ({children, disabled, open, containerRef, modifierClass, ...props}) => {

    if (!open) {
        return null;
    }

    const contRef = containerRef ? containerRef : React.createRef();
    const classes = [styles.itemsContainer, modifierClass];
    if (disabled) classes.push(styles.itemsDisabled);

    return (
        <div className={classes.join(' ')} ref={contRef} {...props}>
            {children}
        </div>
    );
};

DropdownItems.propTypes = {
    modifierClass: PropTypes.string,
    containerRef: PropTypes.any,
    children: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
    open: PropTypes.bool,
};

DropdownItems.defaultProps = {
    modifierClass: '',
    containerRef: null,
    children: null,
    disabled: false,
    open: false,
};

export default DropdownItems;